var render = function () {
  var _obj, _obj$1, _obj$2
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: [
        _vm.$style.container,
        ((_obj = {}), (_obj[_vm.$style.desktop] = _vm.desktop), _obj),
      ],
      on: {
        click: function ($event) {
          return _vm.$emit("toggle")
        },
      },
    },
    [
      _c(
        "div",
        { class: _vm.$style.toggleTitle },
        [
          !_vm.user
            ? [
                !_vm.hideSignUp
                  ? [
                      _c("span", [_vm._v(_vm._s(_vm.signUpLabel))]),
                      _vm._v(" "),
                      _c("span", { class: _vm.$style.slash }, [_vm._v("/")]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.signInLabel))]),
              ]
            : [
                _vm.user.photoURL
                  ? _c("div", {
                      class: _vm.$style.profileImage,
                      style: "background-image: url(" + _vm.user.photoURL,
                      attrs: { "data-testid": "toggleProfileImage" },
                    })
                  : _c("NsIcon", {
                      class: _vm.$style.profileIcon,
                      attrs: { "icon-name": "icon-profile", size: "custom" },
                    }),
                _vm._v(" "),
                _c("div", {
                  class: _vm.$style.greeting,
                  domProps: { innerHTML: _vm._s(_vm.greetingText) },
                }),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.toggleIcon },
        [
          _vm.desktop
            ? _c("NsIcon", {
                class: [
                  _vm.$style.arrowIcon,
                  ((_obj$1 = {}),
                  (_obj$1[_vm.$style.open] = _vm.dropdownOpen),
                  _obj$1),
                ],
                attrs: {
                  "icon-name": "icon-narrow-angle-bottom-24",
                  size: "custom",
                },
              })
            : _c("NsIcon", {
                class: [
                  _vm.$style.arrowIcon,
                  ((_obj$2 = {}),
                  (_obj$2[_vm.$style.open] = _vm.dropdownOpen),
                  _obj$2),
                ],
                attrs: { "icon-name": "icon-direction-mc" },
              }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }